const updateParamsForAuthor = queryParams => {
  const author = queryParams.author;
  if (author && !Array.isArray(author)) {
    const isAnonymous = author === 'anonymous';
    queryParams.anonymous = isAnonymous.toString();
  }
  if (author) {
    // remove the api query param for author since it is irrelevant
    delete queryParams.author;
  }
  return queryParams;
};
export const mapQueryParamsToApiParams = queryParams => {
  queryParams = updateParamsForAuthor(queryParams);
  return queryParams;
};